import { REACT_APP_API_SF } from '../../config'
import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'

const SIMULADOR_ENDPOINT = REACT_APP_API_SF

export async function getLineasFinancieras(
  { brand_id, model_id, id, car_lot_id, tipoVenta, nuevo, año },
  groupBy
) {
  const simuladorBody = {
    car_lot_id: car_lot_id,
    marcaId: brand_id,
    modeloID: model_id,
    versionID: id,
    tipoMMV: nuevo ? '0Km' : 'Usados',
    yearMMV: nuevo ? undefined : año,
    //tipoVenta: tipoVenta ? [tipoVenta] : '',
    //groupBy: groupBy ? groupBy : '',
  }
  return axios.post(`${SIMULADOR_ENDPOINT}/creditsByMMV`, simuladorBody).then((res) => deepFreeze(res.data.data))
}
